import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Page404 = () => {

    const { t } = useTranslation();

    return (

        <Result
            status="404"
            title="404"
            subTitle={t('configurator.404_subtitle')}
            extra={
                <Link to="/">
                    <Button type="primary">{t('configurator.back_home')}</Button>
                </Link>
            }
        />

    );
};
export default Page404;